import React, { FC, useEffect, useState } from 'react';
import { Box } from '@material-ui/core';
import { getVariantDetails } from '../../../store/selectors/variantDetailsSelectors';
import { useSelector } from 'react-redux';
import testAutomationDataStyles from './testAutomationDataStyles';

const TestAutomationData: FC = () => {
  const styles = testAutomationDataStyles();
  const variantDetails = useSelector(getVariantDetails);
  const [vehicleClassification, setVehicleClassification] = useState(null);

  useEffect(() => {
    if (setVehicleClassification && variantDetails) {
      setVehicleClassification(variantDetails?.vehicleClassification);
    }
  }, [variantDetails, setVehicleClassification]);

  return (
    <Box
      className={styles.noDisplay}
      data-vehicle-classification={vehicleClassification}
      data-test={'test:automation_data'}
    />
  );
};

export default TestAutomationData;
